// extracted by mini-css-extract-plugin
export default {"emptySection":"EmptySection_emptySection__waFX-","button":"EmptySection_button__c3Rfs"};